import React from 'react';

import loadingLines from '../styles/LoadingLines.module.css';

const LoadingLines = ({ count = 5, heightLine = 48 }) => (
    <div className={loadingLines.wrapper}>
        {Array.from({ length: count }).map((_, i) => (
            <div key={i} className={loadingLines.loadingLine} style={{ height: `${heightLine}px` }} />
        ))}
    </div>
);

export default LoadingLines;